import { Activity } from "../types/activity";
import { PalletDetail } from "../types/palletDetail";
import { UserLinePermissionsSet } from "../types/userLinePermissionsSet";
import { UserPermission } from "../types/userPermission";
import { WorkorderItem } from "../types/workorderItem";

const UserPermissions = {
    ConsumptionOnLine: 1,
    ConsumptionOpenItems: 2,
    ConsumptionOffLine: 3,
    OnlineLabellingFull: 4,
    OnlineLabellingLimited: 5,
    OfflineLabelling: 6,
    PalletWhsManagement: 7,
    Admin: 8,
    Helpdesk: 9,
    Picking: 10,
    SuperAdmin: 11,
    JWOUser: 12,
    JWOAdmin: 13,
    WOMadmin: 15,
    WOMLect: 16,
    PalEdit: 17,
    PalBlockResort: 18,
    PalBlockQI: 19,
    PalUnBlock: 20,
    PalReprint: 21,
    PalScrap: 22,
    PalDelete: 23,
    PalAddDefect: 24,
    ChangeCloseJob: 25,
    AssignNewJob: 26,
    PalApprove: 37,
    MassPalEdit: 38,
    MassPalAddDefect: 39,
    MassPalRemoveDefect: 40,
    MassPalBlockQI: 41,
    MassPalBlockResort: 42,
    MassPalUnBlock: 43,
    GlobalPermsAdmin: 44,
    LabellingQuantityEditable: 47,
    LabellingNoCopiesEditable: 48,
    LabellingQuantityLayersEditable: 49,
    PalVendorRet: 50
};

const AllowedPalletActions = {
    Edit: 1,
    Issue: 2,
    Consume: 3,
    Delete: 5,
    Scrap: 6,
    Reprint: 7,
    AddDefect: 8,
    BlockAny: 9,
    BlockQi: 10,
    BlockResort: 11,
    BlockPackaging: 12,
    RemoveDefect: 14,
    Unblock: 15
};

function getPalstatActiveButtons(rows: PalletDetail[], bBulk: boolean, isUsSite: boolean) {
    const bottomButtonsOptions = {
        palletDetails: false,
        block: false,
        unblock: false,
        reprint: false,
        scrap: false,
        delete: false,
        copySscc: false
    };

    if (!rows || rows.length === 0) {
        return bottomButtonsOptions;
    }

    if (rows.length > 1 && bBulk) {
        console.log("multiple rows passed");
   
        return {
            palletDetails: false,
            block: true,
            unblock: isUsSite ? false : true,
            reprint: true,
            scrap: true,
            delete: true,
            copySscc: true
        };
    
    } else if (rows.length > 1 && !bBulk) {
        
        bottomButtonsOptions.copySscc = true;

        if (
            rows
                .map(function (x) {
                    return x.allowedPalletActions;
                })
                .every(function (x) {
                    return (
                        x.includes(AllowedPalletActions.BlockAny) ||
                        x.includes(AllowedPalletActions.AddDefect) ||
                        x.includes(AllowedPalletActions.RemoveDefect)
                    );
                })
        ) {
            bottomButtonsOptions.block = true;
        }

        if (
            rows
                .map(function (x) {
                    return x.allowedPalletActions;
                })
                .every(function (x) {
                    return x.includes(AllowedPalletActions.Reprint);
                })
        ) {
            bottomButtonsOptions.reprint = true;
        }

    } else if (rows.length === 1) {
        // console.log('single row passed');

        bottomButtonsOptions.palletDetails = rows.length === 1;
        bottomButtonsOptions.copySscc = true;

        if (
            rows
                .map(function (x) {
                    return x.allowedPalletActions;
                })
                .every(function (x) {
                    return (
                        x.includes(AllowedPalletActions.BlockAny) ||
                        x.includes(AllowedPalletActions.AddDefect) ||
                        x.includes(AllowedPalletActions.RemoveDefect)
                    );
                })
        ) {
            bottomButtonsOptions.block = true;
        }

        if (
            rows
                .map(function (x) {
                    return x.allowedPalletActions;
                })
                .every(function (x) {
                    return x.includes(AllowedPalletActions.Unblock);
                }) && !isUsSite
        ) {
            bottomButtonsOptions.unblock = true;
        }

        if (
            rows
                .map(function (x) {
                    return x.allowedPalletActions;
                })
                .every(function (x) {
                    return x.includes(AllowedPalletActions.Reprint);
                })
        ) {
            bottomButtonsOptions.reprint = true;
        }

        if (
            rows
                .map(function (x) {
                    return x.allowedPalletActions;
                })
                .every(function (x) {
                    return x.includes(AllowedPalletActions.Scrap);
                })
        ) {
            bottomButtonsOptions.scrap = true;
        }
        if (
            rows
                .map(function (x) {
                    return x.allowedPalletActions;
                })
                .every(function (x) {
                    return x.includes(AllowedPalletActions.Delete);
                })
        ) {
            bottomButtonsOptions.delete = true;
        }
    }

    return bottomButtonsOptions;
}

function getWorkorderEnquiryActiveButtons(rows: WorkorderItem[]) {
    const bottomButtonsOptions = {
        offlineLabl: false,
        offlineCons: false,
        assignLabl: false,
        assignCons: false,
        manageWorkorder: false
    };

    if (!rows || rows.length === 0) {
        return bottomButtonsOptions;
    }
    if (rows.length > 1) {
        console.log("multiple rows passed");
    }
    if (rows.length === 1) {
        if (rows[0].userPermissions.includes(UserPermissions.AssignNewJob)) {
            bottomButtonsOptions.assignCons = true;
            bottomButtonsOptions.assignLabl = true;
        }
        if (
            rows[0].userPermissions.includes(UserPermissions.JWOAdmin) ||
            rows[0].userPermissions.includes(UserPermissions.WOMLect) ||
            rows[0].userPermissions.includes(UserPermissions.WOMadmin)
        ) {
            bottomButtonsOptions.manageWorkorder = true;
        }
        if (rows[0].userPermissions.includes(UserPermissions.OfflineLabelling)) {
            bottomButtonsOptions.offlineLabl = true;
        }
        if (rows[0].userPermissions.includes(UserPermissions.ConsumptionOffLine)) {
            bottomButtonsOptions.offlineCons = true;
        }
    }

    return bottomButtonsOptions;
}

function getActivityActiveButtons(rows: Activity[]) {
    const bottomButtonsOptions = {
        consumptionOnline: false,
        consumptionOffline: false,
        labellingOnline: false,
        labellingOffline: false,
        workorderEnquiry: false,
        jobAssign: false,
        jobClose: false,
        jobSchedule: false
    };

    if (!Array.isArray(rows) || rows.every(x => x == null) || rows.length === 0) {
        return bottomButtonsOptions;
    } else if (rows[0].workOrder != null) {
        if (rows[0].perms.includes(UserPermissions.ConsumptionOnLine)) bottomButtonsOptions.consumptionOnline = true;
        if (rows[0].perms.includes(UserPermissions.ConsumptionOffLine)) bottomButtonsOptions.consumptionOffline = true;
        if (rows[0].perms.includes(UserPermissions.ChangeCloseJob)) {
            bottomButtonsOptions.jobClose = true;
            bottomButtonsOptions.jobSchedule = true;
        }
        if (rows[0].perms.includes(UserPermissions.OnlineLabellingLimited)) bottomButtonsOptions.labellingOnline = true;
        if (rows[0].perms.includes(UserPermissions.OnlineLabellingFull)) bottomButtonsOptions.labellingOnline = true;
        if (rows[0].perms.includes(UserPermissions.OfflineLabelling)) bottomButtonsOptions.labellingOffline = true;
    } else if (rows[0].perms.includes(UserPermissions.AssignNewJob)) {
        bottomButtonsOptions.jobAssign = true;
        bottomButtonsOptions.jobSchedule = true;
    }
    bottomButtonsOptions.workorderEnquiry = true;
    return bottomButtonsOptions;
}

const userHasPermissionAnyLine = (permsSet: UserLinePermissionsSet[], permission: UserPermission) => {
    return permsSet.some(x => x.userPermission === permission && x.lineIds.length > 0);
};

const userHasPermissionByLineId = (permsSet: UserLinePermissionsSet[], permission: UserPermission, lineId: number) => {
    return permsSet.some(x => x.userPermission === permission && x.lineIds.includes(lineId));
};

const userHasPermissionByDepartmentId = (permsSet: UserLinePermissionsSet[], permission: UserPermission, departmentId: number) => {
    return permsSet.some(x => x.userPermission === permission && x.departmentIds.includes(departmentId));
};

export {
    UserPermissions,
    AllowedPalletActions,
    getPalstatActiveButtons,
    getWorkorderEnquiryActiveButtons,
    getActivityActiveButtons,
    userHasPermissionAnyLine,
    userHasPermissionByLineId,
    userHasPermissionByDepartmentId
};
